// extracted by mini-css-extract-plugin
export default {"content":"extra-content_content__ruXKd","value":"extra-content_value__iV8b3"};